import { useMemo, useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { I18nextProvider, useTranslation } from 'react-i18next';
import { ConfigProvider } from 'antd';
import enUS from 'antd/locale/en_US';
import roRO from 'antd/locale/ro_RO';

import { StorageNotification } from './components/StorageNotification';
import {
  ThemeProvider,
  NotificationProvider,
  UserProvider,
  FoldersProvider,
  DownloadFilesProvider
} from 'contexts';
import { axiosHeadersUpdater } from './api/axios';

import { publicRoutes, routes } from './routes';

import { i18Next, i18next } from './i18n';
import { Locale } from './utils';

axiosHeadersUpdater();

i18Next();

function App() {
  const { i18n } = useTranslation();

  const antdLocale = useMemo(
    () => (i18n.language === Locale.RO ? roRO : enUS),
    [i18n.language]
  );

  // Keep QueryClient stable across renders to avoid resetting caches and re-triggering loading loops
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false
          }
        }
      })
  );

  const allowPublicAccess =
    new URLSearchParams(window.location.search).get('token') &&
    ['/partner/delegations/'].some((value) => window.location.pathname.startsWith(value));

  return (
    <I18nextProvider i18n={i18next}>
      <ConfigProvider locale={antdLocale}>
        <BrowserRouter>
          <ThemeProvider>
            <QueryClientProvider client={queryClient}>
              <NotificationProvider>
                <DownloadFilesProvider>
                  {/* Temporary */}
                  {/* <Alert
                message={<b>{t('mentenanteMessage')}</b>}
                type="error"
                style={{
                  background: 'red',
                  border: 'none',
                  borderRadius: 0,
                  width: '99.6vw',
                  textAlign: 'center'
                }}
              /> */}

                  {allowPublicAccess ? (
                    <Routes>
                      {publicRoutes.map(({ name, ...rest }) => (
                        <Route key={name} {...rest} />
                      ))}
                    </Routes>
                  ) : (
                    <UserProvider>
                      <FoldersProvider>
                        <StorageNotification />
                        <Routes>
                          {routes.map(({ name, ...rest }) => (
                            <Route key={name} {...rest} />
                          ))}
                        </Routes>
                      </FoldersProvider>
                    </UserProvider>
                  )}
                </DownloadFilesProvider>
              </NotificationProvider>
            </QueryClientProvider>
          </ThemeProvider>
        </BrowserRouter>
      </ConfigProvider>
    </I18nextProvider>
  );
}

export default App;
